import { render, staticRenderFns } from "./GzUnbind.vue?vue&type=template&id=233d0fc9&"
import script from "./GzUnbind.vue?vue&type=script&lang=js&"
export * from "./GzUnbind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports